import React from 'react';

import { Icon } from "src/shared/components/ui/Icon";

import styles from './PageLoader.module.css';

const PageLoader: React.FC = () => (
    <div className={styles.layout}>
        <Icon name={'loader'} className={styles.loader} />
    </div>
)

export default PageLoader;
